// import 'swiper/css/bundle';
import './scss/style.scss';
import {main} from './js/script.js';

const init = () => {
  main();
}
init();
